import React from 'react';
import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';

import data from './data';
import pred_2048_v1 from './pred_2048_v1';
import pred_2048_v2 from './pred_2048_v2';
import pred_2048_v3 from './pred_2048_v3';
import pred_2048_v4 from './pred_2048_v4';
import pred_2048_v5 from './pred_2048_v5';
import pred_4096_v1 from './pred_4096_v1';
import pred_4096_v2 from './pred_4096_v2';
import pred_4096_v3 from './pred_4096_v3';
import pred_4096_v4 from './pred_4096_v4';
import pred_4096_v5 from './pred_4096_v5';

const base = {
  colors: ['#7cb5ec', '#9932cc', '#ff4500', '#228b22', '#434348', '#654321'],
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1
    },
  },
  yAxis: {
    title: { enabled: false },
    min: -0.2,
    max: 0.4,
    tickInterval: 0.1
  }
};

const options1 = {
  ...base,
  title: {
    text: '2048 Reservoir Units',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      data: data.slice(991, 1101),
      name: 'Training Data'
    },
    {
      data: pred_2048_v1.slice(0, 100),
      name: 'Reservoir Prediction-1'
    },
    {
      data: pred_2048_v2.slice(0, 100),
      name: 'Reservoir Prediction-2'
    },
    {
      data: pred_2048_v3.slice(0, 100),
      name: 'Reservoir Prediction-3'
    },
    {
      data: pred_2048_v4.slice(0, 100),
      name: 'Reservoir Prediction-4'
    },
    {
      data: pred_2048_v5.slice(0, 100),
      name: 'Reservoir Prediction-5'
    }
  ]
};

const options2 = {
  ...base,
  title: {
    text: '4096 Reservoir Units',
    margin: 1,
    style: { fontSize: '12px' },
  },
  series: [
    {
      data: data.slice(991, 1101),
      name: 'Training Data'
    },
    {
      data: pred_4096_v1.slice(0, 100),
      name: 'Reservoir Prediction-1'
    },
    {
      data: pred_4096_v2.slice(0, 100),
      name: 'Reservoir Prediction-2'
    },
    {
      data: pred_4096_v3.slice(0, 100),
      name: 'Reservoir Prediction-3'
    },
    {
      data: pred_4096_v4.slice(0, 100),
      name: 'Reservoir Prediction-4'
    },
    {
      data: pred_4096_v5.slice(0, 100),
      name: 'Reservoir Prediction-5'
    }
  ]
};

const opts = { style: { height: '300px', width:'100%' }};

function ReservoirUnits() {
  return (
    <div>
      <h5 className="text-uppercase">Reservoir Units</h5>
      <p>
        An increase in the amount of reservoir units improves the stability of the prediction.
      </p>
      <div className="d-flex flex-wrap w-100">
        <HighchartsReact
          highcharts={Highcharts}
          options={options1}
          containerProps={opts}
        />
        <HighchartsReact
          highcharts={Highcharts}
          options={options2}
          containerProps={opts}
        />
      </div>
    </div>
  );
}

export default ReservoirUnits;
